(() => {
  if (window.__cftWheelPreview) return;
  window.__cftWheelPreview = true;
  const instances = new Map();
  const queryPreview = new URLSearchParams(location.search).get('crftop-wheel-preview') === '1';

  function mount(root) {
    if (instances.has(root)) return;
    const config = JSON.parse(root.querySelector('[data-wheel-config]').textContent);
    // Rewards are not approved: this release only provides an explicit design preview.
    if (!queryPreview && !config.editor && !window.Shopify?.designMode) return;
    const dialog = root.querySelector('[data-wheel-dialog]');
    const rotor = root.querySelector('[data-wheel-rotor]');
    const form = root.querySelector('[data-wheel-form]');
    const spin = root.querySelector('[data-wheel-spin]');
    const result = root.querySelector('[data-wheel-result]');
    const status = root.querySelector('[data-wheel-status]');
    const launch = root.querySelector('[data-wheel-launch]');
    const aborter = new AbortController();
    const options = { signal: aborter.signal };
    const prizes = config.prizes || [];
    let rotation = 0, previewIndex = 0, busy = false, timer, openTimer;
    let previousFocus, previousOverflow, previousPadding, locked = false;
    const step = prizes.length ? 360 / prizes.length : 360;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    rotor.replaceChildren();
    root.hidden = false;
    launch.hidden = false;
    root.querySelector('[data-wheel-preview-note]').hidden = false;
    for (const field of root.querySelectorAll('[data-wheel-email], [data-wheel-consent]')) {
      field.disabled = true;
      field.required = false;
    }
    spin.textContent = config.labels.previewButton;
    spin.disabled = !prizes.length;
    if (!prizes.length) status.textContent = config.labels.unavailable;
    if (prizes.length) rotor.style.background = `conic-gradient(from ${-step / 2}deg, ${prizes.map((prize, i) =>
      `${prize.color} ${i * step}deg ${(i + 1) * step}deg`).join(',')})`;
    prizes.forEach((prize, i) => {
      const angle = i * step * Math.PI / 180;
      const item = document.createElement('div');
      item.className = 'cft-wheel-prize';
      item.style.setProperty('--prize-x', `${50 + Math.sin(angle) * 31}%`);
      item.style.setProperty('--prize-y', `${50 - Math.cos(angle) * 31}%`);
      const itemRotation = prize.image ? 0 : ((i * step + 90) % 180) - 90;
      item.style.setProperty('--prize-rotation', `${itemRotation}deg`);
      item.style.setProperty('--prize-color', prize.textColor);
      item.style.color = prize.textColor;
      if (prize.image) {
        const image = document.createElement('img');
        image.src = prize.image;
        image.alt = '';
        image.width = 160;
        image.height = 180;
        item.append(image);
      } else item.classList.add('cft-wheel-prize--offer');
      const label = document.createElement('span');
      label.className = 'cft-wheel-prize-label';
      label.textContent = prize.label;
      item.append(label);
      rotor.append(item);
    });

    function viewport() {
      root.style.setProperty('--cft-wheel-viewport-height', `${window.visualViewport?.height || innerHeight}px`);
    }
    function otherOverlay() {
      return Array.from(document.querySelectorAll('dialog[open]:not([data-wheel-dialog]), .cft-mobile-menu[open], [data-search-panel]:not([hidden]), #shopify-pc__banner'))
        .some(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
    }
    function open() {
      if (dialog.open) return;
      if (otherOverlay()) { clearTimeout(openTimer); openTimer = setTimeout(open, 500); return; }
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      previousPadding = document.body.style.paddingRight;
      const gutter = innerWidth - document.documentElement.clientWidth;
      if (gutter > 0) document.body.style.paddingRight = `${gutter}px`;
      document.body.style.overflow = 'hidden';
      locked = true;
      viewport();
      dialog.showModal();
      root.querySelector('[data-wheel-close]').focus({ preventScroll: true });
    }
    function unlock() {
      if (!locked) return;
      document.body.style.overflow = previousOverflow;
      document.body.style.paddingRight = previousPadding;
      locked = false;
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    }
    function close() {
      clearTimeout(openTimer);
      if (dialog.open) dialog.close();
      unlock();
    }
    function finish(prize) {
      if (!root.isConnected) return;
      clearTimeout(timer);
      busy = false;
      spin.disabled = false;
      form.hidden = true;
      result.hidden = false;
      root.querySelector('[data-wheel-prize]').textContent = prize.label;
      root.querySelector('[data-wheel-code]').textContent = config.labels.previewNote;
      root.querySelector('[data-wheel-copy]').hidden = true;
      root.querySelector('[data-wheel-shop]').hidden = true;
      status.textContent = config.labels.previewNote;
      root.querySelector('[data-wheel-reset-preview]').focus({ preventScroll: true });
    }
    function reset() {
      if (busy) return;
      result.hidden = true;
      form.hidden = false;
      status.textContent = '';
      spin.focus({ preventScroll: true });
    }
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (busy || !prizes.length) return;
      busy = true;
      spin.disabled = true;
      status.textContent = config.labels.spinning;
      // Preview cycles through the slots; it does not simulate a real probability.
      const index = previewIndex++ % prizes.length;
      const target = (config.pointerAngle - index * step + 360) % 360;
      rotation = Math.floor(rotation / 360 + 5) * 360 + target;
      rotor.style.transitionDuration = reduced.matches ? '0s' : '4.8s';
      rotor.style.transform = `rotate(${rotation}deg)`;
      timer = setTimeout(() => finish(prizes[index]), reduced.matches ? 0 : 4900);
    }, options);
    launch.addEventListener('click', open, options);
    root.querySelector('[data-wheel-close]').addEventListener('click', close, options);
    root.querySelector('[data-wheel-reset-preview]').addEventListener('click', reset, options);
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); }, options);
    dialog.addEventListener('close', unlock, options);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    }, options);
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const targets = Array.from(dialog.querySelectorAll('button:not([disabled]):not([hidden]), a[href], input:not([disabled])'))
        .filter(node => node.getClientRects().length);
      const first = targets[0], last = targets.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }, options);
    window.addEventListener('resize', viewport, options);
    window.visualViewport?.addEventListener('resize', viewport, options);
    const cleanup = () => { clearTimeout(timer); close(); aborter.abort(); instances.delete(root); };
    instances.set(root, { open, close, cleanup });
    if (queryPreview) requestAnimationFrame(open);
  }

  function scan() {
    for (const [root, instance] of instances) if (!root.isConnected) instance.cleanup();
    document.querySelectorAll('[data-cft-wheel]').forEach(mount);
  }
  scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, instance] of instances) if (event.target.contains(root)) instance.cleanup();
  });
  document.addEventListener('shopify:section:select', event => {
    for (const [root, instance] of instances) if (event.target.contains(root)) instance.open();
  });
  document.addEventListener('shopify:section:deselect', event => {
    for (const [root, instance] of instances) if (event.target.contains(root)) instance.close();
  });
})();
